<div class="wishlist-wrapper">

  @if (!wishlist || !wishlist.length) {
    <div class="wishlist__no-items">
      {{ 'wishlist.empty' | translate }}
    </div>
  }

  @for (item of wishlist; track item; let i = $index) {
    <div class="wishlist-item">
      <img class="wishlist-item__img" [src]="getWishlistItemThumbnail(item)" [alt]="item.name" loading="lazy">
      <div class="wishlist-item__info-container">
        <div class="wishlist-item__info">
          <a class="wishlist-item__name main-link" [routerLink]="['/', item.slug]" routerLinkWithLang>{{ item.name }}</a>
          <span class="wishlist-item__price">{{ item.price }}
            <span class="wishlist-item__currency">
              {{ 'global.uah' | translate }}
            </span>
          </span>
        </div>
        <div class="wishlist-item__prices">
          <ul class="wishlist-discount">
            @for (price of item.discountedPrices; track price; let i = $index) {
              <li class="wishlist-discount__item">
                <div class="wishlist-discount__info">
                  <i class="wishlist-discount__icon mbi mbi-cart"></i>
                  <span class="wishlist-discount__from">
                    {{ 'global.from' | translate }}
                  </span>
                  <div class="wishlist-discount__breakpoint"> {{ price.costBreakpoint }}
                    <span class="discount__currency">
                      {{ 'global.uah' | translate }}
                    </span>
                  </div>
                </div>
                <div class="wishlist-discount__price">{{ price.price }}
                  <span class="item__currency">
                    {{ 'global.uah' | translate }}
                  </span>
                </div>
              </li>
            }
          </ul>
          <div class="wishlist-item__buy-wrapper">
            @if (item.isInStock) {
              <button class="wishlist-item__buy btn btn--transparent" (click)="addToCart(item)">
                {{ 'global.to_buy' | translate }}
                @if (item.isLoading) {
                  <preloader class="wishlist-item__preloader">
                  </preloader>
                }
              </button>
            } @else {
              <div class="wishlist-item__buy wishlist-item__buy--out-of-stock">
                {{ 'global.out_of_stock' | translate }}
              </div>
            }
            @if (item.isInWishlist === false) {
              <button class="wishlist-item__heart" (click)="toggleWishlistFlag(item)" type="button">
                <i class="mbi mbi-heart product__wishlist-icon"></i>
              </button>
            }
            @if ( item.isInWishlist === true) {
              <button class="wishlist-item__heart-fill" (click)="toggleWishlistFlag(item)" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
                </svg>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>

